module.exports = __webpack_public_path__ + "media/img/frontend_application/multi-data-icon-ba68adcc6a2f4c72ebcbc259c978735d.png";